import { Action } from '@reduxjs/toolkit';

import { ReduxAction } from 'app/redux/types';

import {
  RecordOfBetEntryType,
  RecordOfBetInfoType,
  RecordOfMatchEntryType,
  RecordOfSportEntryType,
  RecordOfStakeEntryType,
} from '../records';
import { PresetWithDisplayType } from '../types/oneClickBet';

// ---

export const PROCESS_ENTRY = 'BET_SLIP:PROCESS_ENTRY';

export type ProcessEntry = ReduxAction<typeof PROCESS_ENTRY, {
  betInfo: RecordOfBetInfoType;
  bet: RecordOfBetEntryType;
  stake: RecordOfStakeEntryType;
  match: RecordOfMatchEntryType;
  sport: RecordOfSportEntryType;
}>;

export const processEntry = (payload: ProcessEntry['payload']): ProcessEntry => ({
  type: PROCESS_ENTRY,
  payload,
});

// ---

export const PROCESS_ENTRY_SUCCESS = 'BET_SLIP:PROCESS_ENTRY_SUCCESS';

export type ProcessEntrySuccess = Action<typeof PROCESS_ENTRY_SUCCESS>;

export const processEntrySuccess = (): ProcessEntrySuccess => ({
  type: PROCESS_ENTRY_SUCCESS,
});

// ---

export const PROCESS_ENTRY_FAILURE = 'BET_SLIP:COMPLETE_ENTRY_PROCESSING';

export type ProcessEntryFailure = Action<typeof PROCESS_ENTRY_FAILURE>;

export const processEntryFailure = (): ProcessEntryFailure => ({
  type: PROCESS_ENTRY_FAILURE,
});

// ---

export const UPDATE_ONE_CLICK_BET_AMOUNT_PREFERENCE = 'BET_SLIP:UPDATE_ONE_CLICK_BET_AMOUNT_PREFERENCE';

export type UpdateOneClickBetAmountPreference = ReduxAction<
  typeof UPDATE_ONE_CLICK_BET_AMOUNT_PREFERENCE,
  { preference: PresetWithDisplayType }
>;

export const updateOneClickBetAmountPreference = (
  preference: PresetWithDisplayType,
): UpdateOneClickBetAmountPreference => ({
  type: UPDATE_ONE_CLICK_BET_AMOUNT_PREFERENCE,
  payload: { preference },
});

// ---

export const REMOVE_ONE_CLICK_BET_ENTRY = 'BET_SLIP:REMOVE_ONE_CLICK_BET_ENTRY';

export type RemoveOneClickBetEntry = Action<typeof REMOVE_ONE_CLICK_BET_ENTRY>;

export const removeOneClickBetEntry = (): RemoveOneClickBetEntry => ({
  type: REMOVE_ONE_CLICK_BET_ENTRY,
});

